export const ADVANCED_MAPS_ID = 'map-studio';

export const ADVANCED_MAPS_URL = `/${ADVANCED_MAPS_ID}/?new=true`;
export const ADVANCED_MAPS_PATH = `/${ADVANCED_MAPS_ID}`;
